import LogoPlaceholder from "./logo-placeholder.png";
import Slide1 from "./preview/slide-1.png";
import Slide2 from "./preview/slide-2.png";
import Slide3 from "./preview/slide-3.png";
import Slide4 from "./preview/slide-4.png";
import Slide5 from "./preview/slide-5.png";
import Avatar from "./basic-18-avatar.png";
import BgOption1 from "../images/bg-option-1.png";
import BgOption2 from "../images/bg-option-2.png";
import BgOption3 from "../images/bg-option-3.png";

import TemplateImage from "./template-image.png";
import { MultilineView, TextView } from "../../components";
import BaseTemplate from "../base";

class Basic18 extends BaseTemplate {
  constructor() {
    super();
    this.name = "Basic #18";
    this.id = "18";
    this.url = "/ai/carousels/basic-18";
    this.description = "Create a carousel of images";
    this.common_settings = {
      elements: [
        {
          label: "Your Name",
          type: "text",
          value: "Jon Snow",
        },
        {
          label: "Profile Pic",
          type: "logo",
          key: "logo",
          value: {
            type: "image",
            image: Avatar,
          },
        },
        {
          label: "Handle",
          type: "text",
          value: "@jon-snow",
        },
        {
          label: "Background",
          type: "background",
          key: "background_color",
          value: {
            type: "color",
            image: "",
            color: "#B64733",
            color_options: [
              "#2cd4bf",
              "#38bcf7",
              "#feb022",
              "#f87066",
              "#33d583",
              "#818cf8",
              "#f471b6",
              "#bf84fc",
            ],
            image_options: [
              {
                image: BgOption1,
              },
              {
                image: BgOption2,
              },
              {
                image: BgOption3,
              },
            ],
          },
        },

        {
          label: "Primary Color",
          type: "color",
          key: "primary_color",
          style_key_group: "primary",
          value: "#FFFFFF",
        },
        {
          label: "Secondry Color",
          type: "color",
          key: "secondary_color",
          style_key_group: "secondary",
          value: "#000000",
        },
        {
          label: "Primary Font",
          key: "primary_font",
          value: "Vina Sans",
          type: "font",
        },
        {
          label: "Secondary Font",
          key: "secondary_font",
          value: "Work Sans",
          type: "font",
        },
      ],
      swipe_indicator: {
        image: "",
      },
    };
    this.preview_images = [Slide1, Slide2, Slide3, Slide4, Slide5];
    this.slides = [
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "18 Principles For A Perfect LinkedIn Post",
            max_words: 8,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "48px",
              },
              fontFamily: {
                key: "primary_font",
              },
              textAlign: {
                value: "center",
              },
            },
          },
          {
            label: "Subtitle",
            target_key: "title",
            type: "text",
            value: "Some title goes here",
            max_words: 8,
            style: {
              color: {
                key: "background_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              textAlign: {
                value: "center",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: TemplateImage,
          },
        ],
        slide_type: "intro",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "Strong hook?",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "36px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Thousands of posts are shared online every day. 
            
Give people a reason to stop the scroll.`,
            max_words: 15,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: TemplateImage,
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "specific numbers",
            max_words: 5,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "36px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Include specific numbers in your hook so your audience knows what to expect.`,
            max_words: 25,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: TemplateImage,
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "show credibility",
            max_words: 5,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "36px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `The messenger matters. Who said something matters just as much as what they said.`,
            max_words: 25,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "secondary_font",
              },
            },
          },
          {
            label: "Image(Recommended size 400 x 200)",
            target_key: "image",
            type: "image",
            value: TemplateImage,
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "CTA Text",
            type: "text",
            target_key: "cta_text",
            value: "Ask any questions in the comments.",
            max_words: 3,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "48px",
              },
              fontFamily: {
                key: "primary_font",
              },
              textAlign: {
                value: "center",
              },
            },
          },
          {
            label: "Sub CTA Text",
            type: "text",
            target_key: "cta_text",
            value: "Was this helpful?",
            max_words: 3,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              textAlign: {
                value: "center",
              },
              fontWeight: {
                value: "600",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Like, share and save for later.`,
            max_words: 25,
            style: {
              color: {
                key: "secondary_color",
              },
              fontSize: {
                value: "16px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              textAlign: {
                value: "center",
              },
            },
          },
        ],
        slide_type: "outro",
      },
    ];
  }

  setCommonSettings(settings) {
    this.common_settings = settings;
  }

  getPrimaryColor(common_settings) {
    return common_settings.elements[4].value;
  }

  getSecondaryColor(common_settings) {
    return common_settings.elements[5].value;
  }

  getBackgroundColor(common_settings) {
    return common_settings.elements[3].value.color;
  }

  getBackgroundColorVariant(common_settings) {
    return this.getBackgroundColor(common_settings) + "20";
  }

  getBackgroundColorVariantSecond(common_settings) {
    return this.getBackgroundColor(common_settings) + "40";
  }

  getPrimaryFont(common_settings) {
    return common_settings.elements[6]?.value || "Vina Sans";
  }

  getSecondaryFont(common_settings) {
    return common_settings.elements[7]?.value || "Work Sans";
  }

  duplicateSlide(slide, index) {
    let new_slide = JSON.parse(JSON.stringify(slide));
    this.slides.splice(index + 1, 0, new_slide);
    return new_slide;
  }

  renderOutroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div className="absolute w-full h-full top-0 left-0 flex items-center justify-center">
          <div
            className="h-[460px] w-[360px] p-[16px] flex flex-col gap-[24px] items-center justify-center"
            style={{
              backgroundColor: this.getPrimaryColor(commonSettings),
              color: this.getSecondaryColor(commonSettings),
            }}
          >
            <img
              className="object-cover w-[128px] h-[128px]"
              src={
                commonSettings.elements[1].value.image
                  ? commonSettings.elements[1].value.image
                  : LogoPlaceholder
              }
              style={{
                backgroundColor: this.getSecondaryColor(commonSettings),
              }}
              alt=""
            />
            <div
              className="w-fit py-[8px] px-[16px]"
              style={{
                backgroundColor: this.getBackgroundColor(commonSettings),
                color: this.getPrimaryColor(commonSettings),
              }}
            >
              <div className="text-[14px] leading-[20px] font-semibold align-center">
                {slide.elements[1]?.style ? (
                  <MultilineView
                    element={slide.elements[1]}
                    getPropertyByStyleKey={(styleKey) =>
                      this.getPropertyByStyleKey(styleKey, commonSettings)
                    }
                    getValueByKey={(key) =>
                      this.getValueByKey(key, commonSettings)
                    }
                  />
                ) : (
                  <TextView text={slide.elements[1]?.value} />
                )}
              </div>
            </div>
            <div
              className="text-center text-[48px] leading-[48px]"
              style={{
                fontFamily: this.getPrimaryFont(commonSettings),
              }}
            >
              {slide.elements[0]?.style ? (
                <MultilineView
                  element={slide.elements[0]}
                  getPropertyByStyleKey={(styleKey) =>
                    this.getPropertyByStyleKey(styleKey, commonSettings)
                  }
                  getValueByKey={(key) =>
                    this.getValueByKey(key, commonSettings)
                  }
                />
              ) : (
                <TextView text={slide.elements[0]?.value} />
              )}
            </div>

            <div className="flex flex-col items-center gap-[8px]">
              <div className="text-[16px] leading-[24px] font-normal align-center">
                {slide.elements[2]?.style ? (
                  <MultilineView
                    element={slide.elements[2]}
                    getPropertyByStyleKey={(styleKey) =>
                      this.getPropertyByStyleKey(styleKey, commonSettings)
                    }
                    getValueByKey={(key) =>
                      this.getValueByKey(key, commonSettings)
                    }
                  />
                ) : (
                  <TextView text={slide.elements[2]?.value} />
                )}
              </div>
              <svg
                width="98"
                height="20"
                viewBox="0 0 98 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.8633 10.2715C20.8029 12.8956 19.7533 15.3646 17.6277 17.3557C16.6557 18.2662 15.5328 18.9393 14.2825 19.3929C12.9139 19.8904 11.4532 20.0826 10.0026 19.9559C8.55197 19.8292 7.14658 19.3867 5.88484 18.6595C5.78775 18.6036 5.70928 18.6213 5.61765 18.6548C4.43813 19.0849 3.25861 19.5167 2.07735 19.9408C1.72697 20.0665 1.40415 19.9904 1.13994 19.7286C0.872 19.463 0.796014 19.1375 0.92365 18.7815C1.35275 17.5835 1.78632 16.3871 2.22435 15.1924C2.23843 15.1587 2.24398 15.1221 2.24051 15.0857C2.23705 15.0494 2.22467 15.0144 2.20449 14.984C1.77595 14.2471 1.44593 13.457 1.22288 12.6342C0.934744 11.591 0.820392 10.5074 0.884416 9.42699C1.01487 7.27478 1.75726 5.36025 3.1116 3.68341C4.19751 2.34179 5.5516 1.35223 7.1555 0.712482C8.53102 0.160784 10.0126 -0.075481 11.4914 0.021055C15.3188 0.256582 18.6795 2.67595 20.1265 6.24166C20.6147 7.44389 20.8531 8.69681 20.8633 10.2715Z"
                  fill={this.getSecondaryColor(commonSettings)}
                />
                <path
                  d="M56.0886 0.455078C53.0488 0.455078 51.3636 2.62945 51.3636 2.62945C51.3636 2.62945 49.6783 0.455078 46.6385 0.455078C43.4486 0.455078 40.8635 3.01647 40.8635 6.17712C40.8635 10.5165 46.0211 14.7217 47.4586 16.0502C49.1144 17.5796 51.3636 19.5459 51.3636 19.5459C51.3636 19.5459 53.6127 17.5796 55.2685 16.0502C56.706 14.7217 61.8636 10.5165 61.8636 6.17712C61.8636 3.01647 59.2785 0.455078 56.0886 0.455078Z"
                  fill={this.getSecondaryColor(commonSettings)}
                />
                <path
                  d="M97.1367 18.4158C97.1367 18.8848 96.6036 19.1548 96.2255 18.8774L89.839 14.1916C89.6374 14.0438 89.3632 14.0438 89.1617 14.1916L82.7752 18.8774C82.3971 19.1548 81.864 18.8848 81.864 18.4158V1.02759C81.864 0.7114 82.1203 0.455078 82.4365 0.455078H96.5642C96.8803 0.455078 97.1367 0.7114 97.1367 1.02759V18.4158Z"
                  fill={this.getSecondaryColor(commonSettings)}
                />
              </svg>
            </div>
          </div>
        </div>
      </>
    );
  }

  renderMiddleSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div className="absolute w-full h-full top-0 left-0 flex items-center justify-center">
          <div
            className="h-[460px] w-[360px] p-[16px] flex flex-col gap-[24px]"
            style={{
              backgroundColor: this.getPrimaryColor(commonSettings),
              color: this.getSecondaryColor(commonSettings),
            }}
          >
            <div className="w-full relative">
              {slide.elements[2]?.value && (
                <img
                  className="top-[325px] left-[20px] object-cover w-full h-full"
                  src={slide.elements[2]?.value || TemplateImage}
                  alt=""
                />
              )}

              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="absolute top-0 right-0"
              >
                <rect
                  width="40"
                  height="40"
                  fill={this.getBackgroundColor(commonSettings)}
                />
                <path
                  d="M23.4764 19.1666L19.0064 14.6966L20.1849 13.5181L26.6667 19.9999L20.1849 26.4817L19.0064 25.3032L23.4764 20.8332H13.3334V19.1666H23.4764Z"
                  fill={this.getPrimaryColor(commonSettings)}
                />
              </svg>
            </div>
            <div className="flex flex-col gap-[16px]">
              <div
                className="text-[36px] leading-[36px]"
                style={{
                  color: this.getSecondaryColor(commonSettings),
                  fontFamily: this.getPrimaryFont(commonSettings),
                }}
              >
                {slide.elements[0]?.style ? (
                  <MultilineView
                    element={slide.elements[0]}
                    getPropertyByStyleKey={(styleKey) =>
                      this.getPropertyByStyleKey(styleKey, commonSettings)
                    }
                    getValueByKey={(key) =>
                      this.getValueByKey(key, commonSettings)
                    }
                  />
                ) : (
                  <TextView text={slide.elements[0]?.value} />
                )}
              </div>
              <div
                className="text-[16px] leading-[24px] font-normal"
                style={{
                  color: this.getSecondaryColor(commonSettings),
                }}
              >
                {slide.elements[1]?.style ? (
                  <MultilineView
                    element={slide.elements[1]}
                    getPropertyByStyleKey={(styleKey) =>
                      this.getPropertyByStyleKey(styleKey, commonSettings)
                    }
                    getValueByKey={(key) =>
                      this.getValueByKey(key, commonSettings)
                    }
                  />
                ) : (
                  <TextView text={slide.elements[1]?.value} />
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  renderIntroSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <>
        <div className="absolute inset-x-0 top-[32px] px-[40px] flex flex-col items-center gap-[20px]">
          <div
            className="w-fit py-[8px] px-[16px]"
            style={{
              backgroundColor: this.getPrimaryColor(commonSettings),
              color: this.getBackgroundColor(commonSettings),
            }}
          >
            <div className="text-[14px] leading-[20px] font-semibold align-center">
              {slide.elements[1]?.style ? (
                <MultilineView
                  element={slide.elements[1]}
                  getPropertyByStyleKey={(styleKey) =>
                    this.getPropertyByStyleKey(styleKey, commonSettings)
                  }
                  getValueByKey={(key) =>
                    this.getValueByKey(key, commonSettings)
                  }
                />
              ) : (
                <TextView text={slide.elements[1]?.value} />
              )}
            </div>
          </div>
          <div
            className="text-[48px] leading-[48px] font-[400] text-center"
            style={{
              color: this.getPrimaryColor(commonSettings),
              fontFamily: this.getPrimaryFont(commonSettings),
            }}
          >
            {slide.elements[0]?.style ? (
              <MultilineView
                element={slide.elements[0]}
                getPropertyByStyleKey={(styleKey) =>
                  this.getPropertyByStyleKey(styleKey, commonSettings)
                }
                getValueByKey={(key) => this.getValueByKey(key, commonSettings)}
              />
            ) : (
              <TextView text={slide.elements[0]?.value} />
            )}
          </div>
          <div className="h-[40px] flex gap-[12px] items-center ">
            <img
              className="object-cover w-[40px] h-[40px]"
              src={
                commonSettings.elements[1].value.image
                  ? commonSettings.elements[1].value.image
                  : LogoPlaceholder
              }
              style={{
                backgroundColor: this.getBackgroundColor(commonSettings),
              }}
              alt=""
            />
            <div className="flex flex-col">
              <p
                className="text-[16px] leading-[24px] font-semibold"
                style={{
                  color: this.getPrimaryColor(commonSettings),
                }}
              >
                {commonSettings.elements[0].value}
              </p>
              <p
                className="text-[12px] leading-[18px] font-normal"
                style={{
                  color: this.getPrimaryColor(commonSettings),
                }}
              >
                {commonSettings.elements[2].value}
              </p>
            </div>
          </div>
        </div>
        {slide.elements[2]?.value && (
          <img
            className="absolute top-[325px] left-[20px] object-cover w-[360px] h-[155px]"
            src={slide.elements[2].value || TemplateImage}
            alt=""
          />
        )}
      </>
    );
  }

  renderSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div
        key={index}
        className={
          "carousel-slide-container ring-1 ring-gray-200 bg-white relative shrink-0 aspect-[4/5] flex flex-col w-[400px] h-[500px] overflow-hidden " +
          (index !== currentSlide ? "hidden" : "") +
          " index-" +
          index
        }
        style={{
          fontFamily: this.getSecondaryFont(commonSettings),
        }}
      >
        <div className="absolute inset-0">
          {commonSettings.elements[3].value.type === "image" &&
            commonSettings.elements[3].value.image && (
              <img
                className="object-cover w-full h-full"
                src={commonSettings.elements[3].value.image}
                alt=""
              />
            )}
          {commonSettings.elements[3].value.type === "color" && (
            <div
              className="w-full h-full"
              style={{
                backgroundColor: this.getBackgroundColor(commonSettings),
              }}
            ></div>
          )}
        </div>
        {index === 0 &&
          this.renderIntroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index === carouselLength - 1 &&
          this.renderOutroSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
        {index !== carouselLength - 1 &&
          index !== 0 &&
          this.renderMiddleSlide(
            slide,
            index,
            currentSlide,
            carouselLength,
            commonSettings,
            updateSlideElementPosition,
            updateSlideElementSize,
            setCurrentSlideElement,
            previewMode
          )}
      </div>
    );
  }
}

export default Basic18;
